import React from 'react'
import {Box, Typography} from '@mui/material'
import {ISegment} from '@containers/monitoringPlatform/passengerVerification/helpers/buildSegments'
import {formatTime} from '@containers/monitoringPlatform/passengerCharts/helpers/formatTime'

const W = 240
const H = 90
const PAD = 14
const Y_MAX = 50
const ACCENT = 'var(--account-accent, #0C6DDF)'

const SegmentMiniChart = ({segment}: {segment: ISegment}) => {
	const frames = segment.frames
	const from = Math.min(segment.from, ...frames.map(([t]) => t))
	const to = Math.max(segment.to, ...frames.map(([t]) => t))
	const span = Math.max(1, to - from)
	const x = (t: number) => PAD + ((W - 2 * PAD) * (t - from)) / span
	const y = (v: number) => H - PAD - ((H - 2 * PAD) * Math.min(v, Y_MAX)) / Y_MAX
	const line = frames.length > 1 ? 'M' + frames.map(([t, v]) => `${x(t).toFixed(1)},${y(v).toFixed(1)}`).join('L') : ''

	return (
		<Box sx={{p: 0.5}}>
			<Typography sx={{fontSize: '12px', fontWeight: 600, mb: 0.5}}>
				{segment.fromStop} → {segment.toStop}
			</Typography>
			<svg viewBox={`0 0 ${W} ${H}`} width={W} height={H} style={{display: 'block'}}>
				<line x1={PAD} x2={W - PAD} y1={H - PAD} y2={H - PAD} stroke="currentColor" strokeOpacity={0.3}/>
				{line && <path d={line} stroke={ACCENT} strokeWidth={1.5} fill="none"/>}
				{frames.map(([t, v]) => (
					<g key={t}>
						<circle cx={x(t)} cy={y(v)} r={3} fill={ACCENT}/>
						<text x={x(t)} y={y(v) - 6} textAnchor="middle" fontSize={10} fill="currentColor">{v}</text>
					</g>
				))}
				<text x={PAD} y={H - 2} fontSize={9} fill="currentColor" fillOpacity={0.7}>{formatTime(segment.from)}</text>
				<text x={W - PAD} y={H - 2} fontSize={9} textAnchor="end" fill="currentColor" fillOpacity={0.7}>{formatTime(segment.to)}</text>
			</svg>
			{!frames.length && <Typography sx={{fontSize: '11px', opacity: 0.8}}>Немає кадрів підрахунку</Typography>}
		</Box>
	)
}

export default SegmentMiniChart
